import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function ObjectTypeRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/object-type', component: Index, isProtected: true, permissions: ['object_type_index']},
    {path: '/object-type/create', component: Create, isProtected: true, permissions: ['object_type_create']},
    {path: '/object-type/edit/:id', component: Edit, isProtected: true, permissions: ['object_type_edit']},

  ];

  return routes;
}
